import { Link } from "react-router-dom";
import { Activity, Archive, Inbox, Percent, Users } from "lucide-react";
import { useSession } from "@/contexts/SessionContext";
import { AboutRelease } from "@/components/AboutRelease";

const Item = ({ to, icon: Icon, title, body, testId }) => (
  <Link
    to={to}
    data-testid={testId}
    className="flex items-start gap-4 rounded-md border border-archival bg-archival-surface px-5 py-4 min-h-[76px] hover:bg-archival-base transition-colors"
  >
    <Icon size={18} className="text-archival-muted mt-0.5 shrink-0" />
    <span className="min-w-0">
      <span className="block text-[15px] font-medium text-archival-primary">{title}</span>
      <span className="block text-[13px] text-archival-secondary leading-snug mt-0.5">{body}</span>
    </span>
  </Link>
);

export default function MoreHub() {
  const { has } = useSession();
  const canReview = has("BULK_CAPTURE_REVIEW");

  return (
    <div className="space-y-8 pb-16 max-w-3xl" data-testid="more-hub">
      <header className="space-y-1">
        <h1 className="text-4xl sm:text-5xl font-semibold text-archival-primary tracking-tight leading-[1.05]">
          More
        </h1>
        <p className="text-base md:text-lg text-archival-secondary">
          Human decisions, diagnostics and history.
        </p>
      </header>

      <div className="space-y-3">
        <Item to="/queue" icon={Inbox} title="Needs attention" testId="more-needs-attention"
          body="Captured bills waiting on a review, OCR check, vendor, ingredient or conversion decision." />
        <Item to="/vendors/resolve" icon={Users} title="Vendor resolution" testId="more-vendor-resolution"
          body="Match captured vendor names to canonical vendor identities." />
        <Item to="/settings/landed-cost" icon={Percent} title="Tax & landed cost policy" testId="more-landed-cost-policy"
          body="Decide how GST, VAT, TCS, freight and other charges affect the cost of the ingredients you receive." />
        {canReview && (
          <Item to="/validation" icon={Activity} title="Engine health" testId="more-engine-health"
            body="Operational metrics and diagnostics for the Bills engine. Not operator workflow." />
        )}
        <Item to="/legacy/expense-capture" icon={Archive} title="Legacy · Sent to Expense Capture"
          testId="more-legacy-ec"
          body="Historical record of bills handed to Expense Capture before 1OS Bills became canonical. Read-only." />
      </div>
      <AboutRelease />
    </div>
  );
}
